(function () {
  const canPurchase = (hasSize, confirmed) => !hasSize || confirmed;
  const checkoutDestination = () => '/checkout?locale=ar';
  const nextBatch = (items, offset) => items.slice(offset, offset + 8);
  if (typeof module !== 'undefined') module.exports = { canPurchase, nextBatch, checkoutDestination };
  if (typeof document === 'undefined') return;
  const scopeFor = (element) => element.closest('#quick-add-modal-content, [data-product-grid-content]');
  function currentSize(scope) {
    const control = scope?.querySelector('fieldset[data-endure-size], select[data-endure-size]');
    const chosen = control?.matches('select') ? control.selectedOptions[0] : control?.querySelector('input:checked');
    const unavailable = chosen?.getAttribute('aria-disabled') === 'true'
      || chosen?.dataset.optionAvailable === 'false'
      || chosen?.disabled === true;
    return { control, value: chosen && !unavailable ? (chosen.value || '').trim() : '' };
  }
  function updateSizeMessage(scope) {
    const message = scope?.querySelector('[data-endure-size-message]');
    if (!message) return;
    const { control, value } = currentSize(scope);
    if (value) {
      message.textContent = (message.dataset.selected || 'المقاس المختار:') + ' ' + value;
      message.classList.remove('is-error');
    } else if (control) {
      message.textContent = message.dataset.prompt || 'اختار المقاس الأول';
    }
  }
  function guard(element) {
    const scope = scopeFor(element);
    if (!scope) return true;
    const { control, value } = currentSize(scope);
    if (canPurchase(Boolean(control), Boolean(value))) {
      updateSizeMessage(scope);
      return true;
    }
    const message = scope.querySelector('[data-endure-size-message]');
    if (message) {
      message.textContent = message.dataset.prompt || 'اختار المقاس الأول';
      message.classList.add('is-error');
      message.focus({ preventScroll: true });
    }
    control?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }
  function confirmSize(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const input = target.closest('fieldset[data-endure-size] input, select[data-endure-size]');
    if (!input) return;
    const scope = scopeFor(input) || input.closest('.shopify-section');
    if (scope) updateSizeMessage(scope);
  }
  document.addEventListener('click', confirmSize, true);
  document.addEventListener('change', confirmSize, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.shopify-payment-button, shopify-accelerated-checkout');
    if (button && !guard(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.EndureUX = { guard, checkoutDestination, reset: (scope) => updateSizeMessage(scope) };
  function initializeSizeMessages() {
    document.querySelectorAll('[data-endure-size-message]').forEach(message => {
      const scope = message.closest('#quick-add-modal-content, [data-product-grid-content], .shopify-section');
      if (scope) updateSizeMessage(scope);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSizeMessages, { once: true });
  } else {
    initializeSizeMessages();
  }
  document.addEventListener('shopify:section:load', initializeSizeMessages);
  if (!customElements.get('endure-gallery-more')) {
    customElements.define('endure-gallery-more', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const details = this.querySelector('details');
        const grid = this.querySelector('.endure-more__grid');
        const template = this.querySelector('template');
        const button = this.querySelector('[data-endure-more]');
        const status = this.querySelector('[aria-live]');
        if (!details || !grid || !template || !button || !status) return;
        const items = Array.from(template.content.children);
        const imageCount = items.filter(item => item.querySelector('img')).length;
        let offset = 0;
        const append = () => {
          const batch = nextBatch(items, offset);
          for (const item of batch) grid.append(item.cloneNode(true));
          offset += batch.length;
          status.textContent = Math.min(offset, imageCount) + ' / ' + imageCount;
          button.hidden = offset >= items.length;
        };
        details.addEventListener('toggle', () => { if (details.open && !offset) append(); });
        button.addEventListener('click', append);
      }
    });
  }
})();
